var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 4,
    fill: "#85D7B9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_657_10067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4397 4.477L5.83337 9.083C5.8024 9.1141 5.7656 9.13877 5.72507 9.1556C5.68454 9.17243 5.64109 9.1811 5.59721 9.1811C5.55332 9.1811 5.50987 9.17243 5.46934 9.1556C5.42881 9.13877 5.39201 9.1141 5.36104 9.083L3.57971 7.3C3.54874 7.26891 3.51193 7.24424 3.47141 7.22741C3.43088 7.21057 3.38743 7.20191 3.34354 7.20191C3.29966 7.20191 3.2562 7.21057 3.21568 7.22741C3.17515 7.24424 3.13834 7.26891 3.10737 7.3C3.07628 7.33097 3.05161 7.36778 3.03478 7.4083C3.01794 7.44883 3.00928 7.49228 3.00928 7.53617C3.00928 7.58005 3.01794 7.62351 3.03478 7.66403C3.05161 7.70456 3.07628 7.74137 3.10737 7.77234L4.88937 9.554C5.07736 9.74164 5.33211 9.84702 5.59771 9.84702C5.86331 9.84702 6.11806 9.74164 6.30604 9.554L10.912 4.949C10.9431 4.91804 10.9677 4.88126 10.9845 4.84076C11.0013 4.80026 11.01 4.75685 11.01 4.713C11.01 4.66916 11.0013 4.62574 10.9845 4.58525C10.9677 4.54475 10.9431 4.50797 10.912 4.477C10.8811 4.44591 10.8443 4.42124 10.8037 4.40441C10.7632 4.38757 10.7198 4.37891 10.6759 4.37891C10.632 4.37891 10.5885 4.38757 10.548 4.40441C10.5075 4.42124 10.4707 4.44591 10.4397 4.477Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_657_10067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckbox);
export default __webpack_public_path__ + "static/media/green-checkbox.75bea38fc989819b49ec0b81b0ac5761.svg";
export { ForwardRef as ReactComponent };